// @ts-strict-ignore
/** @jsx jsx */
/** @jsxFrag null */
import {jsx} from 'panel';

import {WarningEl} from 'common/components/warning';

import type {WarningHero} from './index';

export function template(this: WarningHero) {
  const {print} = this.getContext(`i18n`);

  return (
    <div sel='.warning-hero-container'>
      <WarningEl
        attrs={{
          'cta-href': this.attr(`cta-href`),
          'cta-text': print(this.params.ctaText),
          'header-text': print(this.params.headerText),
          theme: this.helpers.getTheme(),
          'img-src': this.helpers.getImgSrc(),
          'body-text': this.helpers.getBodyText(),
        }}
        on={{
          ctaClick: this.helpers.handleCtaClick,
        }}
      >
        <slot />
      </WarningEl>
    </div>
  );
}
